import { FcmToken } from '@griply/types';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { createSubscriptionDoc } from 'shared/lib/@tanstack-query';
import { getFcmTokenDoc } from 'shared/services/backend-api';

export const queryKey = 'fcm-token-doc';

export const createFcmTokenDocQueryFn =
  (token: string): QueryFunction<FcmToken | null | undefined, string[]> =>
  async (context) => {
    try {
      return await createSubscriptionDoc<FcmToken>(() => getFcmTokenDoc(token))(
        context,
      );
    } catch {
      // best-effort: a failed read must never block boot; null triggers the create-token self-heal
      return null;
    }
  };

export const useFcmTokenDocQuery = (token?: string | null) =>
  useQuery({
    queryKey: [queryKey, token ?? ''],
    queryFn: createFcmTokenDocQueryFn(token!),
    enabled: !!token,
  });
